import React from 'react'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'

export default function getExternalLink(text, link, isUsdTicket = false) {
    if (isUsdTicket) {
        link = `https://sd.cegeka.com/CAisd/pdmweb.exe?OP=SEARCH+FACTORY=cr+SKIPLIST=1+QBE.EQ.ref_num=${text}`
    }
    return (
        <a href={link} target="_blank" rel="noopener noreferrer">
            <Icon icon={'external-link'} title={text} />
        </a>
    )
}
